import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-8 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
          {/* Left - Feature Request */}
          <div className="flex items-center">
            <a
              href="https://insigh.to/b/vibeyfocus"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-white text-sm font-medium transition-colors border border-gray-300 hover:border-white px-4 py-2 rounded"
            >
              Feature Request
            </a>
          </div>

          {/* Center - Copyright */}
          <div className="text-center">
            <p className="text-sm text-gray-300">
              © {new Date().getFullYear()} VibeyFocus. All rights reserved.
            </p>
          </div>

          {/* Right - Empty (to maintain spacing) */}
          <div className="hidden sm:block w-[120px]"></div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
